import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-header-modal-header',
  templateUrl: './header-modal-header.component.html',
  styleUrls: ['./header-modal-header.component.css']
})
export class HeaderModalHeaderComponent {
  @Input() title: string = '';
  @Input() color: string = '#009000';
  @Input() showClose: boolean = true;
  @Output() close = new EventEmitter<void>();
}
